import { Playground } from 'docz';
import Button from "../../../../../src/components/Button";
import Message from "../../../../../src/components/Message/message";
import * as React from 'react';
export default {
  Playground,
  Button,
  Message,
  React
};